// Unpublished Work © 2026 Deere & Company.

import t from 'tcomb';

export const DigitalUserSearchError = t.struct({
    errorCode: t.String,
    errorMessage: t.String,
    errorStatus: t.String,
    hasError: t.Boolean
}, {
    defaultProps: {
        errorCode: '',
        errorMessage: '',
        errorStatus: '',
        hasError: false
    },
    name: 'DigitalUserSearchError',
    strict: true
});
